import { GridColDef } from '@mui/x-data-grid';
import { DataGridPremium, DataGridPremiumProps } from '@mui/x-data-grid-premium';
import { getDataGridLocalization, MgPrisLocale } from '@retail/utils';
import { Pagination } from '@shared/hooks';
import { CustomPagination } from './CustomPagination';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props<T> extends DataGridPremiumProps {
  rows: T[];
  columns: GridColDef[];
  gridPagination: Pagination;
}

const defaultGridPaginationOptions = [2000, 4000, 8000, 10000];

const PaginatedDataGrid = <T,>({ rows, columns, gridPagination, ...rest }: Props<T>) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Box sx={{ flexGrow: 1, position: 'relative' }}>
      <Box sx={{ position: 'absolute', inset: 0 }}>
        <DataGridPremium
          {...rest}
          rows={rows}
          columns={columns}
          pagination={true}
          paginationMode="server"
          pageSizeOptions={rest.pageSizeOptions ?? defaultGridPaginationOptions}
          localeText={getDataGridLocalization(language as MgPrisLocale)}
          paginationModel={{ page: gridPagination.page, pageSize: gridPagination.pageSize }}
          onPaginationModelChange={(model) => {
            gridPagination.setPage(model.page);
            gridPagination.setPageSize(model.pageSize);
          }}
          disableColumnReorder={rest.disableColumnReorder ?? true}
          slots={{
            ...rest.slots,
            basePagination: CustomPagination,
          }}
        />
      </Box>
    </Box>
  );
};

export default PaginatedDataGrid;
